import {
  setLoadingConfigObject,
  shimmerPlaceholderConfig,
} from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils';

const paymentCardLoadingConfig = [
  {
    main: setLoadingConfigObject('line', 1, '40%', { height: 20 }),
  },
  {
    main: setLoadingConfigObject('square', 1, null, {
      height: 240,
      marginTop: 15,
      width: '100%',
    }),
  },
];
const addNewCardLoadingConfig = [
  {
    main: setLoadingConfigObject('square', 1, null, {
      alignSelf: 'center',
      width: '100%',
      height: 44,
    }),
  },
];

export { paymentCardLoadingConfig, addNewCardLoadingConfig, shimmerPlaceholderConfig };
